/* tslint:disable */
/* eslint-disable */
// @ts-nocheck
/**
 * API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { FanRemixContestWinnersSelectedNotificationAction } from './FanRemixContestWinnersSelectedNotificationAction';
import {
    FanRemixContestWinnersSelectedNotificationActionFromJSON,
    FanRemixContestWinnersSelectedNotificationActionFromJSONTyped,
    FanRemixContestWinnersSelectedNotificationActionToJSON,
} from './FanRemixContestWinnersSelectedNotificationAction';

/**
 * 
 * @export
 * @interface FanRemixContestWinnersSelectedNotification
 */
export interface FanRemixContestWinnersSelectedNotification {
    /**
     * 
     * @type {string}
     * @memberof FanRemixContestWinnersSelectedNotification
     */
    type: string;
    /**
     * 
     * @type {string}
     * @memberof FanRemixContestWinnersSelectedNotification
     */
    groupId: string;
    /**
     * 
     * @type {boolean}
     * @memberof FanRemixContestWinnersSelectedNotification
     */
    isSeen: boolean;
    /**
     * 
     * @type {number}
     * @memberof FanRemixContestWinnersSelectedNotification
     */
    seenAt?: number;
    /**
     * 
     * @type {Array<FanRemixContestWinnersSelectedNotificationAction>}
     * @memberof FanRemixContestWinnersSelectedNotification
     */
    actions: Array<FanRemixContestWinnersSelectedNotificationAction>;
}

/**
 * Check if a given object implements the FanRemixContestWinnersSelectedNotification interface.
 */
export function instanceOfFanRemixContestWinnersSelectedNotification(value: object): value is FanRemixContestWinnersSelectedNotification {
    let isInstance = true;
    isInstance = isInstance && "type" in value && value["type"] !== undefined;
    isInstance = isInstance && "groupId" in value && value["groupId"] !== undefined;
    isInstance = isInstance && "isSeen" in value && value["isSeen"] !== undefined;
    isInstance = isInstance && "actions" in value && value["actions"] !== undefined;

    return isInstance;
}

export function FanRemixContestWinnersSelectedNotificationFromJSON(json: any): FanRemixContestWinnersSelectedNotification {
    return FanRemixContestWinnersSelectedNotificationFromJSONTyped(json, false);
}

export function FanRemixContestWinnersSelectedNotificationFromJSONTyped(json: any, ignoreDiscriminator: boolean): FanRemixContestWinnersSelectedNotification {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'type': json['type'],
        'groupId': json['group_id'],
        'isSeen': json['is_seen'],
        'seenAt': !exists(json, 'seen_at') ? undefined : json['seen_at'],
        'actions': ((json['actions'] as Array<any>).map(FanRemixContestWinnersSelectedNotificationActionFromJSON)),
    };
}

export function FanRemixContestWinnersSelectedNotificationToJSON(value?: FanRemixContestWinnersSelectedNotification | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'type': value.type,
        'group_id': value.groupId,
        'is_seen': value.isSeen,
        'seen_at': value.seenAt,
        'actions': ((value.actions as Array<any>).map(FanRemixContestWinnersSelectedNotificationActionToJSON)),
    };
}

